/**
 * Where the public client bundle's own third-party notices are served (#8914).
 *
 * The file is DERIVED in the bundle action from the bundle's own metafile
 * (`@letsgethome/build-tools/third-party-notices`) and held equal to a fresh
 * derivation by `//web/apps/public:third_party_notices_check`; its name is the
 * ONE constant the writer, the gate and the SSR server's cache rule use too.
 * The rendering is the shared `@letsgethome/ui/third-party-notices` list the
 * staff and localization pages mount as well; only the URL is this app's.
 */
import { THIRD_PARTY_NOTICES_ASSET } from '@letsgethome/build-tools/third-party-notices-asset';

/** The served URL: the SSR server serves `dist/client/<f>` at `/assets/<f>`. */
export const THIRD_PARTY_NOTICES_URL = `/assets/${THIRD_PARTY_NOTICES_ASSET}`;
